export default __webpack_public_path__ + "static/media/Mark-6-HUD-Registration Marks.3902d6e2.jpg";